/* eslint-disable no-await-in-loop */
import { get, getPagedByUrl } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';
import setupDataFetcher from 'helpers/setupDataFetcher';
import { retry } from 'helpers/retry';

let baseUrl = 'accounts';

const NBXAccounts = {
  init: config => ({ baseUrl } = config),

  getOrders: (accountIdArg, nextPageUrlArg) => {
    return new Promise((resolve, reject) => {
      let disposer;

      const onResult = message => {
        resolve(message);
        disposer();
      };
      const onError = message => {
        reject(message);
        disposer();
      };
      const generateFetchKey = ({ accountId, nextPageUrl } = {}) => {
        if (nextPageUrl && accountId) return `accountOrders-${accountId}-${nextPageUrl}`;
        if (accountId) return `accountOrders-${accountId}`;
        return `accountOrders`;
      };
      disposer = setupDataFetcher(onResult, onError, generateFetchKey, null, {
        accountId: accountIdArg,
        nextPageUrl: nextPageUrlArg
      });
    });
  },

  getOrder: (accountId, orderId) =>
    context
      .account(accountId)
      .then(account => get(`${baseUrl}/${account.id}/orders/${orderId}`, account))
      .then(response => response),

  async getStakingTaxReports(year) {
    const account = await context.account();

    return window.REQ_RATE_LIMITER.rateLimitedRequest(async () => {
      const res = await get(`${baseUrl}/${account.id}/staking/tax-reports/${year}`, account);
      return res;
    });
  },

  async getKickbackTaxReports(year) {
    const account = await context.account();

    return window.REQ_RATE_LIMITER.rateLimitedRequest(async () => {
      const res = await get(
        `${baseUrl.replace('/accounts', '')}/card/accounts/${account.id}/kickback/tax-reports/${year}`,
        account
      );
      return res;
    });
  },

  async *getReferralTaxReports(year) {
    let account = await context.account();
    const getPagedByUrlWithRateLimited = retry(async url => {
      account = await context.account();
      return window.REQ_RATE_LIMITER.rateLimitedRequest(() => getPagedByUrl(url, account));
    }, 3);
    let url = `${baseUrl}/${account.id}/referral_tax_reports/${year}`;
    try {
      while (url) {
        const { body, nextPageUrl } = await getPagedByUrlWithRateLimited(url);
        yield body.taxReportItems;
        url = nextPageUrl ? `${baseUrl.replace('/accounts', '')}${nextPageUrl}` : '';
      }
    } catch (e) {
      console.error('Cannot get referral tax report', e);
      throw e;
    }
  },

  async *getTradesHistory(accountId, from, to) {
    const params = new URLSearchParams();
    if (from) params.append('start_date', from.format('YYYYMMDD'));
    if (to) params.append('end_date', to.format('YYYYMMDD'));

    let account = await context.account(accountId);
    const getPagedByUrlWithRateLimited = retry(async url => {
      account = await context.account();
      return window.REQ_RATE_LIMITER.rateLimitedRequest(() => {
        return getPagedByUrl(url, account);
      });
    }, 3);
    let url = `${baseUrl}/${account.id}/trades${params.toString() ? `?${params.toString()}` : ''}`;
    try {
      while (url) {
        const { body, nextPageUrl } = await getPagedByUrlWithRateLimited(url);
        yield body;
        url = nextPageUrl ? `${baseUrl.replace('/accounts', '')}${nextPageUrl}` : '';
      }
    } catch (e) {
      console.error('Cannot get trades history', e);
      throw e;
    }
  }
};

export default NBXAccounts;
